import { render } from "./CampaignWidgets.vue?vue&type=template&id=628f11f6&scoped=true"
import script from "./CampaignWidgets.vue?vue&type=script&lang=js"
export * from "./CampaignWidgets.vue?vue&type=script&lang=js"

import "./CampaignWidgets.vue?vue&type=style&index=0&id=628f11f6&scoped=true&lang=css"
import "./CampaignWidgets.vue?vue&type=style&index=1&id=628f11f6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628f11f6"]])

export default __exports__